/* esm.sh - bn.js@5.2.5 */
export * from "/*bn.js@5.2.5/esnext/bn.mjs";
export { default } from "/*bn.js@5.2.5/esnext/bn.mjs";
